// extracted by mini-css-extract-plugin
export default {"root":"DiscountPromocodesList__root--Ul2lJ","activate":"DiscountPromocodesList__activate--k4CnO","space":"DiscountPromocodesList__space--3vdJ9"};